import * as stylex from "@stylexjs/stylex";
import { FormattedMessage } from "react-intl";
import { breakpoints, colors, layoutAreas } from "../../materials/consts.stylex";
import { themeVars } from "../../materials/theme.stylex";
import { typography } from "../../materials/typography.stylex";
const stylexStyles = {
    highlighted: {
        kMwMTN: "x1dudgmt",
        kWkggS: "x1kf733v",
        kaIpWk: "x1cum3z5",
        $$css: true
    },
    boxH2: {
        kGO01o: "x1l90r2v",
        $$css: true
    },
    boxH3: {
        kGO01o: "xwib8y2",
        kLKAdn: "x1y1aw1k",
        keoZOQ: "x1xmf6yo",
        kE3dHu: "x1tudf5h",
        kpe85a: "x1m2p0i2",
        $$css: true
    },
    title: {
        kMwMTN: "x1vc0dw",
        keoZOQ: "xg87l8a",
        k9WMMc: "x2b8uid",
        $$css: true
    },
    intro: {
        kMwMTN: "x1vc0dw",
        k9WMMc: "x2b8uid",
        ks0D6T: "x7ep2pv",
        kogj98: "xx8cox5",
        $$css: true
    }
};
export function QualityFrameworkTable({ highlighted }) {
    return <>
      <h1 {...stylex.props(typography.heading1Bold, stylexStyles.title)}>
        <FormattedMessage id="Framework for Education Quality" defaultMessage="Framework for Education Quality"/>
      </h1>
      <p {...stylex.props(typography.body2, stylexStyles.intro)}>
        <FormattedMessage id="quality-framework.caption" defaultMessage="This framework proposed in the 2005 EFA Global Monitoring Report has been the standard reference for understanding education quality for more than a decade. It helps understand the importance of all the different themes and topics selected to appear on the Education Progress website."/>
      </p>
      <div className="x1lx81y2 x12efg1r xdt5ytf xdjzykv x78zum5 x1qughib x1qjc9v5 x1hq5gj4 xdj266r">
        <div className="x78zum5 x1q0g3np x1k440pc x1iyjqo2 x1awj2ng">
          <div className="xaiboiz x78zum5 x6s0dn4 x13zrc24 x1l90r2v x163pfp xy13l1i xkib98w x1n2onr6 xdt5ytf x5yr21d x1nhvcw1 xh8yej3 x1vuk045 xs5nyxy x1gmr53x xkj6t0a x1j6awrg x2q1x1w x86avzo x1cnqb4x x1dmosr7 x1srwf7z xpkj8uh xjjriof x1ubldxo xretfr1 x8sem2w x1oykil0 xonp0y1">
            <h2 {...stylex.props(typography.heading2, stylexStyles.boxH2)}>
              <FormattedMessage id="Learners" defaultMessage="Learners"/>
            </h2>
          </div>
          <div className="xaiboiz x78zum5 x6s0dn4 x13zrc24 x1l90r2v x163pfp xy13l1i xkib98w x1n2onr6 xdt5ytf x5yr21d x1nhvcw1 xh8yej3 x1vuk045 xs5nyxy x1gmr53x xkj6t0a x1j6awrg x2q1x1w x86avzo x1cnqb4x x1dmosr7 x1srwf7z xpkj8uh xjjriof x1ubldxo xretfr1 x8sem2w x1oykil0 xonp0y1">
            <h2 {...stylex.props(typography.heading2, stylexStyles.boxH2)}>
              <FormattedMessage id="Systems" defaultMessage="Systems"/>
            </h2>
          </div>
        </div>

        <div className="x78zum5 x1q0g3np x1k440pc x1iyjqo2 x1awj2ng">
          <div className="xaiboiz x78zum5 x6s0dn4 x13zrc24 x1l90r2v x163pfp xy13l1i xkib98w x1n2onr6 xdt5ytf x5yr21d x1nhvcw1 xh8yej3 x1vuk045 xs5nyxy x1gmr53x xkj6t0a x1j6awrg x2q1x1w x86avzo x1cnqb4x x1dmosr7 x1srwf7z xpkj8uh xjjriof x1ubldxo xretfr1 x8sem2w x1oykil0 xonp0y1">
            <h2 {...stylex.props(typography.heading2, stylexStyles.boxH2)}>
              <FormattedMessage id="Schools and classrooms" defaultMessage="Schools and classrooms"/>
            </h2>
            <h3 {...stylex.props(typography.heading3, stylexStyles.boxH3, highlighted === "teachers" && stylexStyles.highlighted)}>
              <FormattedMessage id="Teachers and teaching" defaultMessage="Teachers and teaching"/>
            </h3>
            <h3 {...stylex.props(typography.heading3, stylexStyles.boxH3, highlighted === "school" && stylexStyles.highlighted)}>
              <FormattedMessage id="School and environment" defaultMessage="School and environment"/>
            </h3>
            <h3 {...stylex.props(typography.heading3, stylexStyles.boxH3, highlighted === "material" && stylexStyles.highlighted)}>
              <FormattedMessage id="Material inputs" defaultMessage="Material inputs"/>
            </h3>
          </div>
        </div>

        <div className="x78zum5 x1q0g3np x1k440pc x1iyjqo2 x1awj2ng">
          <div className="xaiboiz x78zum5 x6s0dn4 x13zrc24 x1l90r2v x163pfp xy13l1i xkib98w x1n2onr6 xdt5ytf x5yr21d x1nhvcw1 xh8yej3 x1vuk045 xs5nyxy x1gmr53x xkj6t0a x1j6awrg x2q1x1w x1cnqb4x x1dmosr7 x1srwf7z xpkj8uh xjjriof x1ubldxo xretfr1 x8sem2w x1oykil0 xonp0y1 x1v5kskh">
            <h2 {...stylex.props(typography.heading2, stylexStyles.boxH2)}>
              <FormattedMessage id="Outcomes" defaultMessage="Outcomes"/>
            </h2>
            <h3 {...stylex.props(typography.heading3, stylexStyles.boxH3, highlighted === "learners" && stylexStyles.highlighted)}>
              <FormattedMessage id="For learners" defaultMessage="For learners"/>
            </h3>
            <h3 {...stylex.props(typography.heading3, stylexStyles.boxH3, highlighted === "societies" && stylexStyles.highlighted)}>
              <FormattedMessage id="For societies" defaultMessage="For societies"/>
            </h3>
          </div>
        </div>
      </div>
    </>;
}
